import { ImageLoaderConfig } from '@angular/common';

/**
 * Resize service options interface
 */
export interface IResizeOptions {
    width: number;
    height: number;
    strictDims?: boolean;
}

/**
 * Resize service interface
 */
export abstract class ResizeService {
    abstract loader(config: ImageLoaderConfig): string;
    abstract resize(imageUrl: string, options: IResizeOptions): string;
}
